import { Button } from "@bcc/components/ui/button";
import { HeaderContext } from "@tanstack/react-table";
import { ArrowUpDown } from "lucide-react";
import { useTranslation } from "react-i18next";

export const InvoiceHeaderCell = <TData,>(props: HeaderContext<TData, unknown> | undefined) => {
  const { t } = useTranslation();

  const column = props?.column;
  const headerId = props?.header.id;

  // Check if column is sortable
  const canSort = column?.getCanSort();

  if (!canSort) {
    return <div className="text-sm font-medium">{t(`finance.invoiceTable.columns.${headerId}`)}</div>;
  }

  return (
    <Button
      variant="ghost"
      onClick={() => column?.toggleSorting(column?.getIsSorted() === "asc")}
      className="h-auto p-0 hover:bg-transparent"
    >
      {t(`finance.invoiceTable.columns.${headerId}`)}
      <ArrowUpDown className="ml-2 h-4 w-4" />
    </Button>
  );
};
